"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _CallCard = _interopRequireDefault(require("../CallCard"));
var _CallListSkeleton = _interopRequireDefault(require("../CallListSkeleton"));
var _CallSkeleton = _interopRequireDefault(require("../CallSkeleton"));
var _DatePicker = _interopRequireDefault(require("../../../DatePicker"));
var _InfiniteTabs = _interopRequireDefault(require("../../Common/InfiniteTabs"));
var _Tab = _interopRequireDefault(require("../../../Tab"));
var _ToggleButtonsGroup = _interopRequireDefault(require("../../../ToggleButtonsGroup"));
var _communication = require("../../../../icons-react/communication");
var _excluded = ["activeId", "calls", "hasNextPage", "minimumBatchSize", "onListen", "onLoadRequest", "onSelect", "threshold"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledIncomingIcon = (0, _styledComponents["default"])(_communication.IncomingCall).withConfig({
  displayName: "CallList__StyledIncomingIcon",
  componentId: "sc-111jsq4-0"
})(["width:17px;height:17px;height:15px;margin-top:3px;> *{fill:#00c253;stroke:#00c253;}"]);
var StyledOutgoingIcon = (0, _styledComponents["default"])(_communication.OutgoingCall).withConfig({
  displayName: "CallList__StyledOutgoingIcon",
  componentId: "sc-111jsq4-1"
})(["height:15px;margin-top:3px;> *{fill:#00c253;stroke:#00c253;}"]);
var UnansweredIncomingIcon = (0, _styledComponents["default"])(_communication.IncomingCallUnanswered).withConfig({
  displayName: "CallList__UnansweredIncomingIcon",
  componentId: "sc-111jsq4-2"
})(["width:18px;height:18px;"]);
var ICONS = [{
  Icon: StyledIncomingIcon,
  value: 'incoming'
}, {
  Icon: StyledOutgoingIcon,
  value: 'outgoing'
}, {
  Icon: UnansweredIncomingIcon,
  value: 'unanswered'
}];
var ITEM_SIZE = 133;
var PAGE_SIZE_DEFAULT = 20;
var THRESHOLD_DEFAULT = 5;
var callPropTypes = _CallCard["default"].propTypes;
var infiniteTabsDefaultProps = _InfiniteTabs["default"].defaultProps,
  infiniteTabsPropTypes = _InfiniteTabs["default"].propTypes;
var onLoadRequestDefaultProp = infiniteTabsDefaultProps.onLoadRequest;
var minimumBatchSizePropType = infiniteTabsPropTypes.minimumBatchSize,
  onLoadRequestPropType = infiniteTabsPropTypes.onLoadRequest,
  thresholdPropType = infiniteTabsPropTypes.threshold;
var CallList = /*#__PURE__*/function (_React$PureComponent) {
  function CallList(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CallList);
    _this = _callSuper(this, CallList, [props]);
    _this.state = {
      dateRange: null,
      type: null
    };
    _this.handleChangeDate = _this.handleChangeDate.bind(_this);
    _this.handleFilterChange = _this.handleFilterChange.bind(_this);
    _this.handleLoadPage = _this.handleLoadPage.bind(_this);
    _this.handleToggleTypes = _this.handleToggleTypes.bind(_this);
    _this.isItemLoaded = _this.isItemLoaded.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CallList, _React$PureComponent);
  return (0, _createClass2["default"])(CallList, [{
    key: "handleChangeDate",
    value: function handleChangeDate(dateRange) {
      this.setState({
        dateRange: dateRange
      }, this.handleFilterChange);
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange() {
      var onFilter = this.props.onFilter;
      var _this$state = this.state,
        type = _this$state.type,
        dateRange = _this$state.dateRange;
      onFilter({
        dateRange: dateRange,
        type: type
      });
    }
  }, {
    key: "handleLoadPage",
    value: function handleLoadPage(startIndex, stopIndex) {
      var isNextPageLoading = this.props.isNextPageLoading;
      if (isNextPageLoading) {
        return;
      }
      var onLoadRequest = this.props.onLoadRequest;
      onLoadRequest(startIndex, stopIndex);
    }
  }, {
    key: "handleToggleTypes",
    value: function handleToggleTypes(_ref) {
      var detail = _ref.detail;
      this.setState({
        type: detail.value[0]
      }, this.handleFilterChange);
    }
  }, {
    key: "getItemCount",
    value: function getItemCount() {
      var _this$props = this.props,
        calls = _this$props.calls,
        hasNextPage = _this$props.hasNextPage;
      var size = (0, _size2["default"])(calls);
      return hasNextPage ? size + 1 : size;
    }
  }, {
    key: "isItemLoaded",
    value: function isItemLoaded(index) {
      var calls = this.props.calls;
      return (0, _has2["default"])(calls, "".concat(index, ".call.id"));
    }
  }, {
    key: "errorRenderer",
    value: function errorRenderer() {
      var isNextPageLoading = this.props.isNextPageLoading;
      return isNextPageLoading ? /*#__PURE__*/_react["default"].createElement(StyledCallListSkeleton, null) : /*#__PURE__*/_react["default"].createElement(StyledEmpty, null, "\u041D\u0435\u0442 \u0437\u0432\u043E\u043D\u043A\u043E\u0432.");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        activeId = _this$props2.activeId,
        calls = _this$props2.calls,
        hasNextPage = _this$props2.hasNextPage,
        minimumBatchSize = _this$props2.minimumBatchSize,
        onListen = _this$props2.onListen,
        onLoadRequest = _this$props2.onLoadRequest,
        onSelect = _this$props2.onSelect,
        threshold = _this$props2.threshold,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var _this$state2 = this.state,
        dateRange = _this$state2.dateRange,
        type = _this$state2.type;
      delete props.onFilter; // Fix test error.

      return /*#__PURE__*/_react["default"].createElement(StyledCallList, props, /*#__PURE__*/_react["default"].createElement(StyledFilters, null, /*#__PURE__*/_react["default"].createElement(_ToggleButtonsGroup["default"], {
        key: type,
        onChange: this.handleToggleTypes,
        values: [type]
      }, ICONS.map(function (_ref2) {
        var Icon = _ref2.Icon,
          value = _ref2.value;
        return /*#__PURE__*/_react["default"].createElement(StyledButton, {
          key: value,
          value: value
        }, /*#__PURE__*/_react["default"].createElement(Icon, null));
      })), /*#__PURE__*/_react["default"].createElement(StyledDatePicker, {
        dateFormat: "d MMM yy",
        multiple: true,
        onChange: this.handleChangeDate,
        required: false,
        value: dateRange
      })), hasNextPage || !(0, _isEmpty2["default"])(calls) ? /*#__PURE__*/_react["default"].createElement(StyledInfiniteTabs, {
        isItemLoaded: this.isItemLoaded,
        itemCount: this.getItemCount(),
        itemData: calls,
        itemKey: CallList.getItemKey,
        itemSize: ITEM_SIZE,
        minimumBatchSize: minimumBatchSize,
        onLoadRequest: this.handleLoadPage,
        onSelect: onSelect,
        threshold: threshold,
        value: activeId
      }, function (_ref3) {
        var data = _ref3.data,
          index = _ref3.index,
          style = _ref3.style;
        if (!_this2.isItemLoaded(index)) {
          return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
            style: style
          }, /*#__PURE__*/_react["default"].createElement(StyledCallSkeleton, null));
        }
        var id = CallList.getItemKey(index, data);
        return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
          style: style,
          value: id
        }, /*#__PURE__*/_react["default"].createElement(StyledCallCard, (0, _extends2["default"])({}, data[index], {
          onListen: onListen
        })));
      }) : this.errorRenderer());
    }
  }], [{
    key: "getItemKey",
    value: function getItemKey(index, calls) {
      return (0, _get2["default"])(calls, "".concat(index, ".call.id")) || index;
    }
  }]);
}(_react["default"].PureComponent);
CallList.propTypes = {
  activeId: _propTypes["default"].string,
  calls: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread({}, callPropTypes)).isRequired),
  className: _propTypes["default"].string,
  hasNextPage: _propTypes["default"].bool,
  isNextPageLoading: _propTypes["default"].bool,
  minimumBatchSize: minimumBatchSizePropType,
  onFilter: _propTypes["default"].func,
  onListen: _propTypes["default"].func,
  onLoadRequest: onLoadRequestPropType,
  onSelect: _propTypes["default"].func,
  threshold: thresholdPropType
};
CallList.defaultProps = {
  activeId: null,
  calls: [],
  className: '',
  hasNextPage: false,
  isNextPageLoading: false,
  minimumBatchSize: PAGE_SIZE_DEFAULT,
  onFilter: Function.prototype,
  onListen: Function.prototype,
  onLoadRequest: onLoadRequestDefaultProp,
  onSelect: Function.prototype,
  threshold: THRESHOLD_DEFAULT
};
var StyledCallList = _styledComponents["default"].div.withConfig({
  displayName: "CallList__StyledCallList",
  componentId: "sc-111jsq4-3"
})(["display:flex;flex-direction:column;height:100%;width:100%;"]);
var StyledFilters = _styledComponents["default"].div.withConfig({
  displayName: "CallList__StyledFilters",
  componentId: "sc-111jsq4-4"
})(["display:flex;flex-shrink:0;height:36px;margin-bottom:10px;padding-right:10px;"]);
var StyledInfiniteTabs = (0, _styledComponents["default"])(_InfiniteTabs["default"]).withConfig({
  displayName: "CallList__StyledInfiniteTabs",
  componentId: "sc-111jsq4-5"
})(["flex-grow:1;overflow:hidden;"]);
var StyledCallCard = (0, _styledComponents["default"])(_CallCard["default"]).withConfig({
  displayName: "CallList__StyledCallCard",
  componentId: "sc-111jsq4-6"
})(["border:none;width:100%;"]);
var StyledEmpty = _styledComponents["default"].div.withConfig({
  displayName: "CallList__StyledEmpty",
  componentId: "sc-111jsq4-7"
})(["color:#4d4d4d;height:100%;padding-top:85px;text-align:center;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CallList__StyledButton",
  componentId: "sc-111jsq4-8"
})(["align-items:center;display:flex;svg{height:16px;margin:auto;width:16px;}", ""], function (_ref4) {
  var checked = _ref4.checked;
  return checked && "\n    background-color: #007aff;\n\n    svg > * {\n      fill: none !important;\n      stroke: white !important;\n    }\n  ";
});
var StyledDatePicker = (0, _styledComponents["default"])(_DatePicker["default"]).withConfig({
  displayName: "CallList__StyledDatePicker",
  componentId: "sc-111jsq4-9"
})(["margin-left:10px;width:161px;z-index:1;"]);
var StyledCallListSkeleton = (0, _styledComponents["default"])(_CallListSkeleton["default"]).withConfig({
  displayName: "CallList__StyledCallListSkeleton",
  componentId: "sc-111jsq4-10"
})(["flex-grow:1;overflow:hidden;"]);
var StyledCallSkeleton = (0, _styledComponents["default"])(_CallSkeleton["default"]).withConfig({
  displayName: "CallList__StyledCallSkeleton",
  componentId: "sc-111jsq4-11"
})(["border:none;width:100%;"]);
var _default = exports["default"] = CallList;